import { Link } from "react-router-dom";
import { ROUTES } from "@routing/routes";
import type { CategoryResponse } from "@models/category";

interface SubcategoryBreadcrumbProps {
    chain: CategoryResponse[];
}

export const SubcategoryBreadcrumb = ({
    chain,
}: SubcategoryBreadcrumbProps) => {
    if (chain.length === 0) return null;

    const parent = chain.length >= 2 ? chain[chain.length - 2] : undefined;

    return (
        <nav
            aria-label="Category breadcrumb"
            className="flex items-center gap-2 text-sm text-neutral px-4 py-3"
        >
            {parent && (
                <Link
                    to={ROUTES.BROWSE_CATEGORY(parent.id)}
                    aria-label={`Back to ${parent.name}`}
                    className="text-primary hover:underline"
                >
                    ‹
                </Link>
            )}
            <ol className="flex items-center gap-1">
                {chain.map((cat, index) => {
                    const isLast = index === chain.length - 1;
                    return (
                        <li key={cat.id} className="flex items-center gap-1">
                            {index > 0 && (
                                <span aria-hidden="true" className="opacity-50">
                                    ›
                                </span>
                            )}
                            {isLast ? (
                                <span className="font-medium">{cat.name}</span>
                            ) : (
                                <Link
                                    to={ROUTES.BROWSE_CATEGORY(cat.id)}
                                    className="text-primary hover:underline"
                                >
                                    {cat.name}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
